import {Injectable} from '@angular/core';
import {PermissionPipe} from '../pipes/permission.pipe';
import {TableAction} from '@gatewee/interfaces';

@Injectable()
export class ActionsHelper<T> {
  constructor(private permissionPipe: PermissionPipe) {}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getValueFromPath(obj: T, path: string, raw = false) {
    return (
      path
        .split('.')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((acc: unknown, part: string) => (acc as any)?.[part], obj)
    );
  }

  evaluateActionCondition(row: T, action: TableAction): boolean {
    if (!action.condition) return true;

    return Object.keys(action.condition).every(key => {
      const value = action.condition?.[key];

      if (key === 'permission') {
        return this.permissionPipe.transform(value as string);
      }

      if (
        action?.condition?.[key] === true &&
        row[key as keyof T] !== undefined
      )
        return true;

      let isNot = false;
      let expectedValue = value;

      if (typeof value === 'string' && value.startsWith('!')) {
        isNot = true;
        expectedValue = value.slice(1);
      }

      const actualValue = this.getValueFromPath(row, key, true);

      if (expectedValue === '__exists__') {
        return actualValue !== undefined && actualValue !== null;
      }

      if (Array.isArray(expectedValue)) {
        const actualValueTyped = actualValue as string | number | boolean;
        return isNot
          ? !expectedValue.includes(actualValueTyped)
          : expectedValue.includes(actualValueTyped);
      }

      return isNot
        ? actualValue !== expectedValue
        : actualValue === expectedValue;
    });
  }
}
